module.exports = __webpack_public_path__ + "static/media/01-galeria-05-louis-vuitton-mobile@2x.8e1ef2c0.jpg";